import React from 'react';
import PropTypes from 'prop-types';
import {
  Component,
} from './styles';

const LogoZedoc = ({
  // eslint-disable-next-line react/prop-types
  className,
  themeMode,
}) => {
  return (
    <Component
      className={className}
      themeMode={themeMode}
      width="100%"
      height="100%"
      viewBox="0 0 876 184"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="zedocLogoTitle"
    >
      <title id="zedocLogoTitle">ZEDOC Logo</title>
      <path d="M379.5 153.9c1.4.1 2.2.2 3 .2 13.2-.1 26.4.2 39.6-.6 16-.9 30.8-5.4 42.5-17.2 8.1-8.3 12.2-18.5 13.8-29.8 1.7-12.1 1.4-24.1-2-36-5.5-18.9-18.7-29.8-37.2-35-9.8-2.8-19.8-3.6-29.9-3.7-8.8-.1-17.5 0-26.3 0-1 0-2.1.1-3.5.2v4.8c-.1 9.8.1 19.6-.6 29.4-.6 7.7-7.9 13-15.6 12.4-7.3-.5-13.2-6.8-13.2-14.4-.1-15.4-.1-30.8 0-46.2 0-7.4 5.7-13.1 13.3-13.2 18.5-.1 37-.5 55.4.1s36.3 4.2 52.4 13.9c19.5 11.7 31.1 29 35.8 51.1.5 2.2 1.2 4.3 1.1 6.5-.1 3.3 1.5 3.7 4.3 3.7 10.4-.1 20.9-.1 31.4 0 2.2 0 3.1-.7 3.5-2.9 5.9-29.2 30.3-51.9 59.8-56 38.1-5.4 73.3 20 80.3 57.5 4.1 22.1-1.2 42.1-15.7 59.5-11.4 13.6-26.1 21.9-43.5 24.5-21.5 3.3-40.8-2.3-57.5-16.5-12.4-10.6-20.1-24.1-23.7-40.1h-38c-1.6 6.7-2.8 13.4-4.9 19.7-9.4 28-29.2 44.6-57.5 51.7-12.5 3.2-25.3 4.1-38.2 4.3-14.4.3-28.7.1-43.1.1-7.9 0-13-3.5-14.9-10.2-.3-1-.4-2.1-.4-3.1 0-15.4-.1-30.8 0-46.2 0-6.9 5.2-13.1 11.6-14.2 7.5-1.3 14.5 2.6 16.8 9.6.7 2.2 1 4.5 1 6.8.1 8.5 0 17.1 0 25.7.1 1 .1 2.2.1 3.6zM617 133.4c23.1 0 41.6-18.4 41.5-41.4 0-22.8-17.7-41.5-41.4-41.6-23.5-.1-41.6 18.5-41.7 41.6-.1 22.9 18.6 41.4 41.6 41.4zM213.8 32.5v47.4c1.4.1 2.8.2 4.1.2H285c7.8 0 13.3 5.2 13.5 12.5.2 7.6-5.5 13.4-13.2 13.4h-71.4v47.9c1.4.1 2.7.2 4.1.2h78.2c8 0 12.7 3.6 14.7 10.7 1.9 6.8-3.2 15.1-10.2 16.4-2.2.4-4.4.6-6.6.6h-94c-4.5 0-8.7-.9-12.1-4.4-2.5-2.7-3.8-5.8-3.8-9.4 0-49.9-.1-99.8 0-149.8 0-7.5 5.9-13.4 13.5-13.5 32.2-.1 64.4-.1 96.6 0 8.1 0 14 6.2 13.9 14.1-.1 7.7-6 13.6-14 13.6h-76.3c-1.4.1-2.6.1-4.1.1zM41.7 154.3h89.5c8.1 0 13.5 4.4 14.8 12.1 1.1 6.3-3.7 13.4-10 14.7-1.8.4-3.8.6-5.6.6H19.3c-10.1 0-16.7-5.1-18.6-14.5-1.2-5.7 1.3-10.4 4.8-14.7L50.8 97C67.4 76.7 84 56.5 100.6 36.3c1-1.3 2-2.6 3.5-4.7h-4.3c-27.2 0-54.5-.1-81.7.1-7.1 0-14.2-4.8-14.5-13.5C3.3 10.7 9.8 4.7 18 4.7h108.9c7.3 0 12.9 3.1 16 9.7 3.2 6.8 1.8 13.2-3 19-12.1 14.7-24.1 29.5-36.2 44.2-11.9 14.6-23.9 29.1-35.9 43.6-8.5 10.4-17 20.9-25.5 31.3-.1.5-.1.9-.6 1.8zm675.9-61.8c.3-20 5.4-38.3 17.4-54.4 14.6-19.6 33.9-31.7 58-35.9 19.5-3.4 38.7-2.5 56.8 5.8 7.5 3.4 14.4 8.1 21.2 12.9 5.6 3.9 6.1 13.2 1.8 19.1-4.1 5.5-12.4 7.3-18.4 3.7-2.4-1.5-4.7-3.2-7.1-4.7-12.4-8.2-26.2-10.2-40.7-9.2-13 .9-24.7 4.9-34.8 13-14 11.1-21.8 25.5-22.9 43.5-.9 14.5 1.5 28.2 9.6 40.3 13.8 20.4 33.1 30.1 57.9 28.3 12.2-.9 23-5.1 32.7-12.6 8.6-6.6 18.8-4.2 22.8 5.1 2.2 5.2.6 12.3-3.8 15.8-14.6 11.9-31 19-49.9 20.3-24.2 1.7-46.4-3.5-65.8-18.5-17.9-13.9-29.3-31.9-32.9-54.5-1-6-1.3-12-1.9-18z" />
    </Component>
  );
};

LogoZedoc.propTypes = {
  themeMode: PropTypes.oneOf([
    'light',
    'dark',
  ]),
};

LogoZedoc.defaultProps = {
  themeMode: null,
};

export default LogoZedoc;
